import React from 'react';
import PropTypes from 'prop-types';
import { isFunction } from 'lodash';
import Radio from '../radio/Radio';
import { combineClassNames } from '../../css';

const RadioToggle = ({
  options,
  renderLabel,
  selected,
  className,
  optionsClassName,
  onChange,
  analyticsKey,
}) => {
  return (
    <div className={combineClassNames(['radio-toggle', className])}>
      {options.map((option) => {
        const checked = isFunction(selected)
          ? selected(option)
          : option === selected;
        const subClassName = combineClassNames([
          optionsClassName,
          'radio-toggle__option',
          checked ? 'radio-toggle__option--checked' : '',
        ]);
        return (
          <Radio
            key={option.id}
            analyticsKey={analyticsKey}
            value={option.id}
            className={subClassName}
            checked={checked}
            onChange={() => onChange(option)}>
            {renderLabel(option)}
          </Radio>
        );
      })}
    </div>
  );
};

RadioToggle.propTypes = {
  options: PropTypes.array.isRequired,
  renderLabel: PropTypes.func.isRequired,
  selected: PropTypes.any,
  onChange: PropTypes.func.isRequired,
};

export default RadioToggle;
